<div class="change-password-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="{{ data.horse.horseId }}Id">Sale Horse Status</h5>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="modal.dismiss('Cross click')"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" [disabled]="saleHorseForm.invalid" (click)="onSave()">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="saleHorseForm">
      
      <div class="row">
        <!-- Status Field -->
        <div class="col-md-12">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="status"
              >Status</label
            >
            <div class="col-sm-9">
              <select id="status"
                      class="form-select"
                      formControlName="status"
                      (change)="statusChanged()"
                      [ngClass]="{ 'form-required-border': saleHorseForm.get('saleResult')?.invalid && (saleHorseForm.get('saleResult')?.touched || saleHorseForm.get('saleResult')?.dirty) }"
                      required>
                <option *ngFor="let status of statuses" [value]="status.id">{{ status.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Price Field -->
        <div class="col-md-12">
          <div class="form-group row mt-2">
            <label class="col-sm-3 col-form-label" for="price"
              >Price</label
            >
            <div class="col-sm-9">
              <input type="number"
                id="price"
                class="form-control"
                formControlName="price"
                [readonly]="!isShowPrice()"
                [required]="isShowPrice()"
                [ngClass]="{ 'form-required-border': saleHorseForm.get('price')?.invalid && (saleHorseForm.get('price')?.touched || saleHorseForm.get('price')?.dirty) }"
                 />
            </div>
          </div>
        </div>

        <!-- Reserve Price Field -->
        <div class="col-md-12">
          <div class="form-group row mt-2">
            <label class="col-sm-3 col-form-label" for="reserve-price"
              >Reserve Price</label
            >
            <div class="col-sm-9">
              <input type="number"
                 id="reserve-price"
                 class="form-control"
                 formControlName="reservePrice"
                 [ngClass]="{ 'form-required-border': saleHorseForm.get('reservePrice')?.invalid && (saleHorseForm.get('reservePrice')?.touched || saleHorseForm.get('reservePrice')?.dirty) }"
                  />
            </div>
          </div>
        </div>

        <!-- Buyer Field -->
        <div class="col-md-12">
          <div class="form-group row mt-2">
            <label class="col-sm-3 col-form-label" for="buyer"
              >Buyer</label
            >
            <div class="col-sm-9">
              <input type="text"
              id="buyer"
              class="form-control"
              [readonly]="!isShowBuyer()"
              [required]="isShowBuyer()"
              formControlName="buyer"
              [ngClass]="{ 'form-required-border': saleHorseForm.get('buyer')?.invalid && (saleHorseForm.get('buyer')?.touched || saleHorseForm.get('buyer')?.dirty) }" />
            </div>
          </div>
        </div>

        <!-- Buyer Field -->
        <div class="col-md-12" [hidden]="!isShowDateSold()">
            <div class="form-group row mt-2">
                <label class="col-sm-3 col-form-label" for="date">Date</label>
                <div class="col-sm-9">
                    <date-picker formControlName="dateSold" [lotOrHipText]="data?.sale.lotOrHipText"
                                 [hidden]="!isShowDateSold()"
                                 [required]="isShowDateSold()"
                                 [ngClass]="{ 'form-required-border': saleHorseForm.get('dateSold')?.invalid && (saleHorseForm.get('dateSold')?.touched || saleHorseForm.get('dateSold')?.dirty) }">
                    </date-picker>
                </div>
            </div>
        </div>
      </div>
  
    </form>
  </div>
  
</div>
